// AddConferenceParticipant.js

import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import {
  Box, Button, Card, CardContent, Grid, Typography,
  TextField, InputLabel, MenuItem, FormControl,
  Select, FormHelperText, Radio, RadioGroup,
  FormControlLabel, FormLabel
} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';

const AddConferenceParticipant = () => {
  const history = useHistory();
  const eventid = localStorage.getItem('eventid');
  const eventName = localStorage.getItem('eventname');
  const [submitting, setSubmitting] = useState(false);
  const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
  const [conferenceJoinAsData, setConferenceJoinAsData] = useState([]);
  const [assignModules, setAssignModules] = useState([]);

  const [participantData, setParticipantData] = useState({
    name: "",
    instituteWorkPlace: "",
    city: "",
    phone: "",
    email: "",
    saudiCouncilno: "",
    price: "",
    error_list: [],
  });

  const [nameTitle, setNameTitle] = useState('');
  const [joinAs, setJoinAs] = useState('');
  const [gender, setGender] = useState('');
  const [country, setCountry] = useState('Saudi Arabia');
  const [registrationType, setRegistrationType] = useState('');
  const [checkmodules, setCheckedModules] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [abstractHomeSetup, setAbstractHomeSetup] = useState({ color_code_two: "" });

  useEffect(() => {
    axios.get(`api/conference-category-front-index?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setConferenceCategoryData(res.data.conferenceCategories);
      } else {
        swal('Error', "Error fetching categories", 'error');
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`api/get-conference-particpant-join-as?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setConferenceJoinAsData(res.data.gcpj);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`api/modules-access?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setAssignModules(res.data.mod);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setAbstractHomeSetup(res.data.HomePageSetup);
      }
    });
  }, [eventid]);

  let backGroundButtonByEvent = abstractHomeSetup.color_code_two || '#145348';

  const handleChange = (e) => {
    setParticipantData({ ...participantData, [e.target.name]: e.target.value });
  };

  const handleTitleChange = (e) => setNameTitle(e.target.value);
  const handleJoinAsChange = (e) => setJoinAs(e.target.value);
  const handleGenderChange = (e) => setGender(e.target.value);
  const handleCountryChange = (e) => setCountry(e.target.value);
  const handleRegTypeChange = (e) => setRegistrationType(e.target.value);

  const handleModuleCheckbox = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    if (checked) {
      setCheckedModules([...checkmodules, value]);
    } else {
      setCheckedModules(checkmodules.filter((v) => v !== value));
    }
  };
  const [emailErro, setEmailErro] = useState('');
  const addParticipant = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const data = {
      eventid,
      checkmodules,
      nameTitle,
      joinAs,
      participant_name: participantData.name,
      participant_saudi_council_no: participantData.saudiCouncilno,
      participant_email: participantData.email,
      participant_password: participantData.password,
      participant_conference_category: registrationType,
      participant_contact: participantData.phone,
      participant_gender: gender,
      p_instituteWorkPlace: participantData.instituteWorkPlace,
      participant_city: participantData.city,
      participant_country: country,
      participant_price: participantData.price,
    };

    axios.get('/sanctum/csrf-cookie').then(() => {
      axios.post(`/api/store-conference-participant-join`, data).then(res => {
        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success');
          history.push('/admin/conference/manage-particpant');
        }
        else if (res.data.status === 401) {
          setEmailErro(res.data.message);
          swal("Warning", res.data.message, "warning");
          history.push('/admin/conference/add-particpant');
          setParticipantData("");
          setNameTitle('');
          setJoinAs('');
          setGender('');    
          setCountry('Saudi Arabia');
          setRegistrationType('');
          setCheckedModules([]);  
          setSubmitting(false);

        } else {
          setSubmitting(false);
          setParticipantData({ ...participantData, error_list: res.data.validate_error });
        }
      });
    });
  };



  return (
    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
      <Box sx={{ color: '#000', mt: 5 }}>
        <h4>
          <Button sx={{ float: 'right', mt: 2, mr: 1, backgroundColor: backGroundButtonByEvent }}
            color='success' size='small' variant='contained' onClick={() => history.goBack()}>
            Back
          </Button>
          <Button sx={{ float: 'right', mt: 2, mr: 2, backgroundColor: backGroundButtonByEvent }}
            color='success' size='small' variant='contained' component={Link} to="/admin/conference/join-as">
            Add Join As
          </Button>
        </h4>
        <Card sx={{ width: '60vw' }}>
          <CardContent>
            <Typography component="h1" variant="h5">
              Add Conference Participant
            </Typography>
            <Box component="form" onSubmit={addParticipant} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={4}>
                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel>Title</InputLabel>
                    <Select value={nameTitle} onChange={handleTitleChange}>
                      <MenuItem value={'Mr'}>Mr</MenuItem>
                      <MenuItem value={'Mrs'}>Mrs</MenuItem>
                      <MenuItem value={'Ms'}>Ms</MenuItem>
                      <MenuItem value={'Dr'}>Dr</MenuItem>
                      <MenuItem value={'Prof'}>Prof</MenuItem>
                      <MenuItem value={'Eng'}>Eng</MenuItem>
                      <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel>Join As</InputLabel>
                    <Select value={joinAs} onChange={handleJoinAsChange}>
                      {conferenceJoinAsData?.map((val) => (
                        <MenuItem key={val.id} value={val.id}>{val.join_as}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TextField required fullWidth label="Name" name="name"
                    required
                    value={participantData.name} onChange={handleChange}
                    helperText={participantData.error_list?.name} />
                </Grid>

                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Gender</FormLabel>
                    <RadioGroup row value={gender} onChange={handleGenderChange}>
                      <FormControlLabel value="male" control={<Radio />} label="Male" />
                      <FormControlLabel value="female" control={<Radio />} label="Female" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TextField fullWidth label="City" name="city"
                    value={participantData.city} onChange={handleChange} />
                </Grid>

                <Grid item xs={6}>
                  <TextField fullWidth label="Mobile" name="phone"
                    value={participantData.phone} onChange={handleChange} />
                </Grid>

                <Grid item xs={6}>
                  <TextField fullWidth label="Email" name="email"
                    value={participantData.email} onChange={handleChange}
                    required
                    helperText={emailErro} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label="Password" type="password" name="password"
                    value={participantData.password} onChange={handleChange}
                    required
                    helperText={participantData.error_list?.password} />
                </Grid>

                <Grid item xs={6}>
                  <TextField fullWidth label="Saudi Council No" name="saudiCouncilno"
                    value={participantData.saudiCouncilno} onChange={handleChange} />
                </Grid>

                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel>Conference Category</InputLabel>
                    <Select required value={registrationType} onChange={handleRegTypeChange}>
                      {conferenceCategoryData.map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>{cat.conference_category_title}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{participantData.error_list?.conference_category_id}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TextField fullWidth label="Price" name="price"
                    value={participantData.price} onChange={handleChange} />
                </Grid>
              </Grid>

              <Grid container justifyContent="flex-end">
                <Button disabled={disabled} type="submit" variant="contained"
                  sx={{ mt: 5, backgroundColor: backGroundButtonByEvent }}
                  disabled={submitting}>

                  {submitting ? 'Registering...' : 'Add Participant'}

                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default AddConferenceParticipant;
